import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { settingList } from './contants';
import { SettingItem } from './index.d';
import BrowserHistory from '@helpers/BrowserHistory';

interface ItemProps {
  item: SettingItem;
  status: boolean;
  onClick: () => void;
}

const Item = (props: ItemProps) => {
  const { item, status, onClick } = props;

  return (
    <div className="flex" styleName="item" onClick={onClick}>
      <div className="flex" styleName='item-title-row'>
        <span styleName="item-title">{ item.title }</span>
        <div className="flex" styleName='right-container'>
          <span styleName="item-status">{status ? '已开启' : '未开启'} </span>
          <i styleName='right-arrow' className="iconfont icon-tubiaoyanse" />
        </div>
      </div>
      <span styleName="item-desc">{ item.desc }</span>
    </div>
  )
}

const GuardSettingEntry = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [customGuardStatus, setCustomGuardStatus] = useState(false);
  const [smartGuardStatus, setSmartGuardStatus] = useState(false);

  const getGuardSettingSwitchInfo = async(switchType: number) => {
    const result = await Http.post(Api.GetGuardSettingSwitchInfo,
      { snCode: params.current.sncode, company: params.current.company, type: switchType }
    );
    if(result && result?.data) {
      if (switchType === 1) {
        setCustomGuardStatus(result.data === true);
      } else if (switchType === 2) {
        setSmartGuardStatus(result.data === true);
      }
    }
  }

  const onCustomGuardSettingClick = () => {
    BrowserHistory.push(`${PUBLIC_URL}/customguardsetting?sncode=${params.current.sncode}&company=${params.current.company}`);
  }

  const onSmartGuardSettingClick = () => {
    
    BrowserHistory.push(`${PUBLIC_URL}/smartguardsetting?sncode=${params.current.sncode}&company=${params.current.company}`);
  }

  const renderSettingItem = () => {
    const items = settingList.map((item: any, index: number) => {
      return (
        <Item 
          key={ index } 
          item={ item } 
          status={item.type === 1 ? customGuardStatus : smartGuardStatus}
          onClick={item.type === 1 ? onCustomGuardSettingClick : onSmartGuardSettingClick}/>
      )
    });

    return items;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onDataInit = async() => {
    await getGuardSettingSwitchInfo(1);
    await getGuardSettingSwitchInfo(2);
  }

  useEffect(() => {
    onDataInit();
  }, [onDataInit])

  return (
    <div styleName="container">
      <NavBar
        title="安全守护"
      />
      <div styleName="list">
        { renderSettingItem() }
      </div>
    </div>
  )
}

export default GuardSettingEntry;
